import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
import { ToWords } from 'to-words';
import { parseValue } from '../utils/Common';

function GenerateCommissionInvoice() {
    const [invoiceData, setInvoiceData] = useState([]);
    const location = useLocation();
    var counter = 0;

    useEffect(() => {
        setInvoiceData(location.state?.invoiceData || {});
    }, [location.state]);

    const downloadPdfDocument = (invoice) => {
        const input = document.getElementById(`invoice-${invoice.comm_invoice_no}`);
        if (!input) return;
    
        const a4Width = 595.28;
        const a4Height = 841.89;
        const padding = 0;
    
        html2canvas(input, {
            scale: 2,
            useCORS: true,
            logging: true,
            windowWidth: (a4Width + padding) * 2,
            windowHeight: a4Height * 2
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/jpeg', 1.0);
            const pdf = new jsPDF('p', 'pt', 'a4');
    
            const imgWidth = a4Width - padding * 2;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
            if (imgHeight <= a4Height) {
                pdf.addImage(imgData, 'JPEG', padding, 0, imgWidth, imgHeight);
            } else {
                let y = 0;
                while (y < imgHeight) {
                    pdf.addImage(imgData, 'JPEG', padding, -y, imgWidth, imgHeight);
                    y += a4Height;
                    if (y < imgHeight) pdf.addPage();
                }
            }
    
            pdf.save(`invoice-${invoice.invoice_no}.pdf`);
        });
    }


    const toWords = new ToWords({
        localeCode: 'en-IN',
        converterOptions: {
            currency: true,
            ignoreDecimal: false,
            ignoreZeroCurrency: false,
            doNotAddOnly: false,
        }
    });

    const convertToWords = (amount) => {
        const numAmount = parseFloat(amount);
        if (isNaN(numAmount)) return '';
        return toWords.convert(numAmount, { currency: true });
    };
    
    if (invoiceData && invoiceData.length > 0) {
        return (
            <div id='invoice' className='mb-5'>
            {
                invoiceData.map((invoiceData,index) => {
                    counter = 0;
                    if (invoiceData?.seller) {
                        return (
                            <>
                            <div key={index} className='mb-5' id={`invoice-${invoiceData.comm_invoice_no}`}>
                                <div className='bill-customer' id="testId">
                                    <div className='invoice'>
                                        <div className='invoice-head col-md-12'>
                                        <h2>{"Tax Invoice / Bill of Supply"}</h2>
                                        </div>
                                        <div className='customer-details'>
                                            <div className='customer-details-head'>
                                                <h2>Customer Details:</h2>
                                            </div>
                                            <div className='bill-details row'>
                                                <div className='billing-address col-md-6'>
                                                    <div className='billing-address-head'><h4>Billing Address :</h4></div>
                                                    <div className='billing-address-details'>
                                                        <div className="user-address row d-flex align-items-center">
                                                        <label className="col-4  col-md-6">Name :</label>
                                                        <div className="col-8  col-md-6 text-truncate">{invoiceData.seller.first_name + " " + invoiceData.seller.middle_name + " " + invoiceData.seller.last_name}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Address :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData?.product_item?.product?.seller_address?.address || invoiceData?.seller_service?.seller_address?.address || invoiceData?.offline_sale_product_datum?.offline_sale?.seller_address?.address || invoiceData?.seller?.seller_addresses[0]?.address || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Pincode :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData?.product_item?.product?.seller_address?.pincode || invoiceData?.seller_service?.seller_address?.pincode || invoiceData?.offline_sale_product_datum?.offline_sale?.seller_address?.pincode || invoiceData?.seller?.seller_addresses[0]?.pincode || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>State :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData?.product_item?.product?.seller_address?.state || invoiceData?.seller_service?.seller_address?.state || invoiceData?.offline_sale_product_datum?.offline_sale?.seller_address?.state || invoiceData?.seller?.seller_addresses[0]?.state || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Pan No :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.seller?.user_business?.pan_no || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Email :</label>
                                                            <div className= ' col-8 col-md-6 text-break word-wrap'>{invoiceData.seller.email || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Mobile No :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.seller.mobile_phone || "N/A"}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='shipping-address  col-md-6'>
                                                    <div className='shipping-address-head'><h4>Shipping Address :</h4></div>
                                                    <div className='shipping-address-details'>
                                                        <div className="user-address row d-flex align-items-center">
                                                        <label className="col-4  col-md-6">Name :</label>
                                                        <div className="col-8  col-md-6 text-truncate">{invoiceData.seller.first_name + " " + invoiceData.seller.middle_name + " " + invoiceData.seller.last_name}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Address :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData?.product_item?.product?.seller_address?.address || invoiceData?.seller_service?.seller_address?.address || invoiceData?.offline_sale_product_datum?.offline_sale?.seller_address?.address || invoiceData?.seller?.seller_addresses[0]?.address || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Pincode :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData?.product_item?.product?.seller_address?.pincode || invoiceData?.seller_service?.seller_address?.pincode || invoiceData?.offline_sale_product_datum?.offline_sale?.seller_address?.pincode || invoiceData?.seller?.seller_addresses[0]?.pincode || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>State :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData?.product_item?.product?.seller_address?.state || invoiceData?.seller_service?.seller_address?.state || invoiceData?.offline_sale_product_datum?.offline_sale?.seller_address?.state || invoiceData?.seller?.seller_addresses[0]?.state || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Pan No :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.seller?.user_business?.pan_no || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Email :</label>
                                                            <div className= ' col-8 col-md-6 text-break word-wrap'>{invoiceData.seller.email || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Mobile No :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.seller.mobile_phone || "N/A"}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='customer-details'>
                                            <div className='billing-address-head'>
                                                <h4>Supply by:</h4>
                                            </div>
                                            <div className='bill-details row'>
                                                <div className='billing-address   col-md-6'>
                                                    <div className='billing-address-details'>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Name :</label>
                                                            <div className= ' col-8 col-md-6'>Shree Raja Ram Raj Biz Pvt Ltd</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Address :</label>
                                                            <div className= ' col-8 col-md-6'>RZ 101/45 D, Street No. 6, Mohan Nagar, Pankha Road, New Delhi 110046	</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Pincode :</label>
                                                            <div className= ' col-8 col-md-6'>110046</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>GSTIN :</label>
                                                            <div className= ' col-8 col-md-6'>07ABFCS2976L1ZR</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>State :</label>
                                                            <div className= ' col-8 col-md-6'>DELHI</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Pan No :</label>
                                                            <div className= ' col-8 col-md-6'>ABFCS2976L</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='shipping-address   col-md-6'>
                                                    <div className='shipping-address-details'>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Invoice Number :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.comm_invoice_no || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Invoice Date :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.updated_at || "N/A"}</div>
                                                        </div>
                                                         
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Order ID (SRRR Number) :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.order.order_id || "N/A"}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Mode of Payment  :</label>
                                                            <div className= ' col-8 col-md-6'>Online</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Amount received  :</label>
                                                            <div className= ' col-8 col-md-6'>Rs. {parseValue(invoiceData.commission_charges, 'float') || 0}</div>
                                                        </div>
                                                        <div className='user-address row'>
                                                            <label className= ' col-4 col-md-6'>Date & Time :</label>
                                                            <div className= ' col-8 col-md-6'>{invoiceData.updated_at || "N/A"}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div className='invoice-table'>
                                            <div className='invoice-table-head'>
                                                <h4>Details:</h4>
                                            </div>
                                            <div className='invoice-table-body'>
                                                <table className="orders-table report-margin table-responsive">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>Commission Charges</th>
                                                            <th>Taxable Supply</th>
                                                            <th>IGST
                                                                <th>Rate %</th>
                                                                <th>Amount</th>
                                                            </th>
                                                            <th>CGST
                                                                <th>Rate %</th>
                                                                <th>Amount</th>
                                                            </th>
                                                            <th>SGST / UTGST
                                                                <th>Rate %</th>
                                                                <th>Amount</th>
                                                            </th>
                                                            <th>TOTAL
                                                                <th>GST</th>
                                                                <th>Invoice Amount</th>
                                                                <th>R. Off</th>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>1</td>
                                                            <td>{parseValue(invoiceData?.commission_charges || 0,'float')}</td>
                                                            <td>{parseValue(invoiceData?.comm_taxable_value || 0,'float')}</td>
                                                            <td>
                                                                <td>18</td>
                                                                <td>{parseValue(invoiceData?.comm_igst || 0,'float')}</td>
                                                            </td>
                                                            <td>
                                                                <td>18</td>
                                                                <td>{parseValue(invoiceData?.comm_cgst || 0,'float')}</td>
                                                            </td>
                                                            <td>
                                                                <td>18</td>
                                                                <td>{parseValue(invoiceData?.comm_sgst || 0,'float')}</td>
                                                            </td>
                                                            <td>
                                                                <td>
                                                                {
                                                                    parseValue(invoiceData?.comm_igst, 'float') +
                                                                    parseValue(invoiceData?.comm_cgst, 'float') +
                                                                    parseValue(
                                                                        invoiceData?.comm_sgst ??
                                                                        0,
                                                                        'float'
                                                                    )
                                                                }
                                                                </td>    
                                                                <td>{parseValue(invoiceData?.commission_charges || 0,'float')}</td>
                                                                <td>
                                                                    {
                                                                        parseValue(
                                                                        parseValue(invoiceData?.commission_charges || 0,'float') - 
                                                                        parseValue(invoiceData?.comm_taxable_value || 0,'float') - 
                                                                        parseValue(invoiceData?.comm_igst || 0,'float') -
                                                                        parseValue(invoiceData?.comm_cgst || 0,'float') -
                                                                        parseValue(invoiceData?.comm_sgst || 0,'float'), 'float')
                                                                    }
                                                                </td>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="10">
                                                                <tr>
                                                                    <td><b>Total</b></td>
                                                                    <td>Rs. {parseValue(invoiceData.commission_charges || 0,  'float')}</td>
                                                                    <td>{convertToWords(parseValue(invoiceData.commission_charges || 0, 'float'))}</td>

                                                                </tr>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className='footer-data row'>
                                            <b className='col-md-6'>Whether GST payable under reverse charge  ?</b>
                                            <h6 className='col-md-6'>No</h6>
                                        </div>
                                        <div className='footer-data row'>
                                            <div className='col-md-12 row'>
                                                <h5 className='col-md-6'>Remarks:</h5>
                                                <div className='col-md-6 row'>
                                                    <label className='col-md-2'>for</label>
                                                    <div className='col-md-4'>
                                                        <b>
                                                            Shree Raja Ram Raj Biz Pvt Ltd
                                                        </b>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='footer-data row'>
                                            <div className='col-md-12 row'>
                                                <h5 className='col-md-6'></h5>
                                                <div className='col-md-6'>
                                                    <div className='Sign-image-vendor'>Signed</div>
                                                    <div className='Authorised-Signatory'>Authorised Signatory</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button onClick={() => downloadPdfDocument(invoiceData)} className="btn btn-primary mt-3">Download Invoice</button>

                            </>
                        );
                    } else {
                        return 'No Invoice';
                    }
                })
            }
            </div>
        )
    }
}

export default GenerateCommissionInvoice;
